import {
  appQrCode,
  appQrCodeBF,
  envelope,
  gtaApple,
  gtaAppleBF,
  gtaAndroid,
  gtaAndroidBF,
  appLogoApple,
  appLogoAndroid
} from '../shared/svgData';
import { checkMobile, randomId } from '../shared/utils';

// COMP
import Button from '../Button';

const Banner = ({
  cta,
  description,
  input,
  inputPlaceholder,
  blackFriday,
  description2,
  percentage,
  appBannerOptions,
  salePromo,
  blackFridayPreview,
  bfpDescription,
  bfpDescription2,
  bfpDescription3,
  blackFriday24,
  DowloadCopy,
  buttonLink,
  buttonLinkText,
  gaBlockTitle,
  gaBlockName,
  gaBlockId,
  cyberMonday24,
  cyberMonday24BGVid,
  cyberMonday24BGVidType,
  saleExtra10,
  app20,
  endSale25,
  endSale25BGVid,
  endSale25BGVidType
}) => {
  return (
    <section
      id={`banner-section-${randomId()}`}
      className={
        `container my-24 lg:my-48 relative ${
          blackFriday && '!my-20 lg:!my-24'
        } ${(saleExtra10 || app20) && '!mb-20 lg:!mt-24 lg:!mb-32'} ${
          blackFridayPreview && '!mt-0 mb-20 lg:mb-32 max-w-none p-0'
        } ${blackFriday24 && '!mb-0'}` +
        (appBannerOptions?.classes ? ' ' + appBannerOptions.classes : '')
      }
    >
      {(cyberMonday24 || endSale25) && (
        <video
          className={`absolute top-0 z-10 after:absolute after:top-0 after:w-full after:h-auto after:object-cover ${
            endSale25 ? 'after:opacity-50 w-full h-full object-cover' : ''
          }`}
          loop
          autoPlay
          muted
          playsInline
          preload="auto"
        >
          <source
            src={cyberMonday24BGVid || endSale25BGVid}
            type={cyberMonday24BGVidType || endSale25BGVidType}
          />
        </video>
      )}
      {saleExtra10 && (
        <a
          alt={buttonLinkText + gaBlockTitle}
          className={`after:absolute after:inset-0 after:z-10 after:w-full after:h-full hover:text-current ${
            cyberMonday24 && 'after:z-20'
          }`}
          href={buttonLink}
          data-name={gaBlockTitle}
          data-creative={gaBlockName}
          data-id={gaBlockId}
          data-position={'button-slot-' + 1}
          data-type="banner-button"
        ></a>
      )}
      {app20 && (checkMobile.iOS() || checkMobile.Android()) && (
        <a
          alt={buttonLinkText + gaBlockTitle}
          className={`after:absolute after:inset-0 after:z-10 after:w-full after:h-full hover:text-current`}
          href={
            checkMobile.iOS()
              ? 'https://apps.apple.com/us/app/sevenstore/id1179005758'
              : 'https://play.google.com/store/apps/details?id=com.sevenstore.sevenapp&gl=GB'
          }
          data-name={gaBlockTitle}
          data-creative={gaBlockName}
          data-id={gaBlockId}
          data-position={'button-slot-' + 1}
          data-type="banner-button"
        ></a>
      )}
      <div
        className={`px-10 pb-10 md:p-10 flex flex-col md:flex-row rounded-lg gap-6 ${
          app20 && 'banner-app-20-off text-white gap-10 h-fit pt-10'
        } ${
          saleExtra10 &&
          'banner-extra-10 bg-black text-white gap-10 h-fit pt-10'
        } ${
          blackFriday
            ? 'banner-app-20 text-white lg:!items-center'
            : blackFridayPreview
            ? `${endSale25 ? 'banner-end-sale-25 !bg-black !text-white' : ''} ${
                cyberMonday24 && 'banner-cm !bg-[#D2FF01] !text-black'
              } relative p-10 banner-bf-preview !rounded-none bg-black text-white !h-auto aspect-[64/95] ${
                blackFriday24 && 'aspect-[7/9]'
              } md:aspect-[48/25] xl:aspect-[165/65] !flex-col !items-center !justify-end md:!justify-center !gap-52 md:!gap-0`
            : 'banner bg-[#E6E6E6]'
        } ${
          salePromo && '!h-[145vw] md:!h-auto'
        } justify-end md:items-end md:justify-between h-[135vw] md:h-96 lg:text-xl`}
      >
        {blackFriday24 && (
          <a
            alt={buttonLinkText + gaBlockTitle}
            className={`after:absolute after:inset-0 after:z-10 after:w-full after:h-full hover:text-current ${
              (cyberMonday24 || endSale25) && 'after:z-20'
            }`}
            href={buttonLink}
            data-name={gaBlockTitle}
            data-creative={gaBlockName}
            data-id={gaBlockId}
            data-position={'button-slot-' + 1}
            data-type="banner-button"
          ></a>
        )}
        {cyberMonday24 && (
          <div
            className={
              'after:absolute after:inset-0 after:z-10 after:w-full after:h-full after:bg-gradient-to-t after:from-[#D2FF01] after:from-50% lg:after:from-60% xl:after:from-50%'
            }
          ></div>
        )}
        {endSale25 && (
          <div
            className={
              'after:absolute after:inset-0 after:z-10 after:w-full after:h-full after:bg-gradient-to-t after:from-black/80 after:from-40% lg:after:from-50% xl:after:from-40%'
            }
          ></div>
        )}
        <div
          className={`md:w-[30rem] lg:w-[42rem] flex flex-col gap-4 ${
            blackFridayPreview &&
            '!w-auto items-center justify-center md:gap-2 relative xl:top-16'
          } ${blackFriday24 && '!top-0'} ${
            (cyberMonday24 || endSale25) &&
            '!top-14 md:!top-0 xl:!top-20 -mx-8 z-10'
          } ${(saleExtra10 || app20) && '!w-full md:!w-7/12'}`}
        >
          <h3
            className={`${
              blackFriday || saleExtra10 || app20
                ? 'capitalize text-4xl lg:text-6xl font-extrabold pb-6 tracking-[-0.8px]'
                : blackFridayPreview
                ? `capitalize text-7xl lg:text-9xl ${
                    blackFriday24 && 'text-8xl lg:!text-10xl'
                  } ${
                    (cyberMonday24 || endSale25) && '!text-75xl lg:!text-10xl'
                  } leading-none text-center font-bold font-sans tracking-[-1.8px] lg:tracking-[-1.966px]`
                : 'uppercase text-xl font-bold pb-4'
            }`}
          >
            {cta}
          </h3>
          <h6
            className={`lg:w-[30rem] ${
              blackFriday || saleExtra10 || app20
                ? 'text-2xl lg:text-4xl font-base tracking-[-0.8px]'
                : blackFridayPreview
                ? `text-2xl lg:!text-7xl tracking-normal font-bold !w-full text-center pb-8 md:pb-12 ${
                    blackFriday24 && '!pb-0'
                  }`
                : 'text-md lg:text-lg tracking-normal'
            } ${salePromo && '!w-full lg:!w-10/12'} ${
              (saleExtra10 || app20) && '!w-full lg:!w-10/12'
            } w-[26rem]`}
          >
            {description}
            {blackFriday && (
              <span className="block">
                {description2}
                <span className="font-extrabold"> {percentage}</span>
              </span>
            )}
            {blackFridayPreview && (
              <span className="flex flex-row gap-2 md:gap-6 justify-center items-center">
                {bfpDescription}
                <span className="font-base">{bfpDescription2}</span>
                {bfpDescription3}
              </span>
            )}
          </h6>
          {(blackFriday || blackFriday24 || saleExtra10) && (
            <p className="block !text-md font-base tracking-[-0.8px]">
              {!endSale25 && 'Excludes launches'}
            </p>
          )}
          {app20 && (
            <p className="block !text-md font-base tracking-[-0.8px]">
              *Full Price Only. Exclusions Apply.
            </p>
          )}
          {blackFridayPreview && !blackFriday24 && (
            <p className="uppercase text-black bg-white py-2 px-8 rounded block text-center !text-xl md:!text-6xl font-bold tracking-normal">
              {description2}
            </p>
          )}
          {input && (
            <div className="newsletter-signup pb-0">
              <div className="signup-form-wrapper">
                <form
                  className="signup-form relative"
                  data-newsletter-signup=""
                >
                  <input
                    className="pl-8 w-full pr-24 lg:pr-20 h-24 lg:h-16 rounded-lg placeholder:font-bold placeholder:tracking-wider"
                    name="email"
                    placeholder={inputPlaceholder}
                  />
                  <button
                    id="banner-button"
                    className="banner-form-button h-16 w-16 lg:h-12 lg:w-16 absolute right-6 lg:right-3 top-4 lg:top-2"
                    type="submit"
                  >
                    {envelope}
                  </button>
                </form>
              </div>
            </div>
          )}
        </div>
        {(saleExtra10 || blackFriday24) && (
          <Button
            buttonColour={cyberMonday24 ? 'black' : 'white'}
            buttonLink={buttonLink}
            buttonLinkText={buttonLinkText}
            gaBlockTitle={gaBlockTitle}
            gaBlockName={gaBlockName}
            gaBlockId={gaBlockId}
            buttonSlotNumber={2}
            buttonOptions={{
              classes: {
                wrapper: `w-full md:w-auto ${
                  !saleExtra10 && 'md:absolute md:bottom-28'
                }`
              }
            }}
            buttonAdditionalClasses={{
              classes: 'z-20'
            }}
          />
        )}
        {app20 &&
          (checkMobile.iOS() || checkMobile.Android() ? (
            <Button
              buttonColour={'white'}
              buttonLink={
                checkMobile.iOS()
                  ? 'https://apps.apple.com/us/app/sevenstore/id1179005758'
                  : 'https://play.google.com/store/apps/details?id=com.sevenstore.sevenapp&gl=GB'
              }
              buttonLinkText={buttonLinkText}
              gaBlockTitle={gaBlockTitle}
              gaBlockName={gaBlockName}
              gaBlockId={gaBlockId}
              buttonSlotNumber={2}
              buttonOptions={{
                classes: {
                  wrapper: `w-full md:w-auto`
                }
              }}
              buttonAdditionalClasses={{
                classes: 'z-20'
              }}
            />
          ) : (
            checkMobile.any() === null && (
              <div className={`hidden lg:flex text-end items-start h-72`}>
                <h3 className="mt-6 -mr-8">GET THE APP</h3>
                {appQrCodeBF}
              </div>
            )
          ))}
        {!saleExtra10 && !blackFriday24 && !app20 && (
          <>
            <div
              className={`pb-6 md:pb-0 lg:h-full ${
                blackFridayPreview &&
                '!h-auto !w-full md:!w-auto relative md:absolute md:right-4 lg:right-20 md:bottom-4 lg:bottom-20 mx-0 !p-5 gap-3 md:gap-0 rounded bg-white text-black flex flex-row md:flex-col items-center justify-center'
              }`}
            >
              {blackFridayPreview && (
                <p className="font-sans !text-md !font-bold !tracking-normal text-left lg:text-center">
                  {DowloadCopy}
                </p>
              )}

              {checkMobile.iOS() && (
                <div
                  id="gta-apple"
                  className={`md:h-24 lg:hidden ${
                    blackFridayPreview && 'flex justify-center w-1-2'
                  }`}
                >
                  <a
                    href="https://apps.apple.com/us/app/sevenstore/id1179005758"
                    className="h-full"
                  >
                    {blackFriday
                      ? gtaAppleBF
                      : blackFridayPreview
                      ? appLogoApple
                      : gtaApple}
                  </a>
                </div>
              )}
              {checkMobile.Android() && (
                <div
                  id="gta-google"
                  className={`md:h-24 lg:hidden ${
                    blackFridayPreview && 'flex justify-center w-1-2'
                  }`}
                >
                  <a
                    href="https://play.google.com/store/apps/details?id=com.sevenstore.sevenapp&gl=GB"
                    className="h-full"
                  >
                    {blackFriday
                      ? gtaAndroidBF
                      : blackFridayPreview
                      ? appLogoAndroid
                      : gtaAndroid}
                  </a>
                </div>
              )}
              {checkMobile.any() === null && (
                <div
                  className={`hidden lg:flex text-end items-start h-72 ${
                    blackFridayPreview &&
                    'md:!flex items-center justify-center md:!h-40 lg:!h-44'
                  }`}
                >
                  {!blackFridayPreview && (
                    <h3 className="mt-6 -mr-8">GET THE APP</h3>
                  )}
                  {blackFriday ? (
                    appQrCodeBF
                  ) : blackFridayPreview ? (
                    <div className="flex flex-row items-center justify-center h-full">
                      <span className="h-full">{appQrCode}</span>
                      <span className="flex flex-col items-center justify-center gap-4">
                        <span id="gta-apple">
                          <a
                            href="https://apps.apple.com/us/app/sevenstore/id1179005758"
                            className="h-full"
                          >
                            {appLogoApple}
                          </a>
                        </span>
                        <span id="gta-google">
                          <a
                            href="https://play.google.com/store/apps/details?id=com.sevenstore.sevenapp&gl=GB"
                            className="h-full"
                          >
                            {appLogoAndroid}
                          </a>
                        </span>
                      </span>
                    </div>
                  ) : (
                    appQrCode
                  )}
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default Banner;
